module.exports = __webpack_public_path__ + "img/logo.8699d9a4.png";